<template>
  <form @submit.prevent="createAmostra()">
    <div class="container offset">

      <div class="custom-form">
        <div class="form-group">
          <label class="question-style">Nome:*</label>
          <input v-model="nome" type="name" class="form-control" placeholder="Insira aqui o nome do campo..."
            required />
        </div>
        <div class="form-group">
          <label class="question-style">Ano:*</label>
          <input v-model="ano" type="number" min="1900" class="form-control" placeholder="Insira aqui o ano do campo..."
            required />
        </div>
        <div class="form-group">
          <label class="question-style">Descrição:*</label>
          <textarea v-model="descricao" class="form-control" rows=5 placeholder="Insira aqui a descrição do campo..."
            required></textarea>
        </div>
        <!---------------- RADIOS ----------------->

        <div class="row mb-2" v-if="typeof data === 'object' || typeof data === 'array'">
          <div class="col">
            <label class="mr-sm-2 text-nowrap label-filtro" for="inlineFormCustomSelect">Selecione o município:*
            </label>

            <select v-model="municipioData" class="form-control" id="municipio" required>
              <option v-for="municipio in data" :key="municipio.nome" :value="municipio.idMunicipio">
                {{ municipio.nome }}
              </option>
            </select>
          </div>
        </div>

      </div>
      <div class="button-div pt-3">
        <Button section="green-outline" value="Salvar Campo" :isOutline="true" :hasIcon="true"
          iconName="save" />
      </div>
    </div>
  </form>

</template>

<script>

import Button from '../../components/Button'
//import Swal from 'sweetalert2';
import { Notyf } from "notyf";
import formularios from '../../store/modules/formularios';
const notyf = new Notyf({
  duration: 5000,
  position: {
    x: "left",
    y: "bottom",
  }
});

export default {
  name: "AddField",
  data() {
    return {
      nome: "",
      ano: new Date().getFullYear(),
      descricao: "",
      municipioData: "",
      forms: "",
      teste: [],
    }
  },
  components: {
    Button
  },
  props: {
    data: [Object, String, Array]
  },
  async created() {
    await this.$store.dispatch("setListFormulariosByRegional", this.$route.params.idRegional);
    this.forms = formularios;
  },
  computed: {
    formularios() {
      var forms = this.$store.getters.getListFormularios;
      const mapIds = forms.map(this.getIds);
      return mapIds;
    },
    ues() {
      var ues = this.$store.getters.getListUE;
      return ues;
    },
  },
  methods: {
    getIds(item) {
      return item.id_formulario;
    },

    getTurmas(item) {
      return item.idturma
    },

    manageTurmas(idMunicipio, idCampo) {
      var turmas = [];
      this.ues.forEach(async e => {
        const payload = {
          idMunicipio: idMunicipio,
          idUnidade: e.idue,
        };
        await this.$store.dispatch("setListTurmas", payload);

        turmas = this.$store.getters.getListTurma.map(this.getTurmas);

        if (turmas.length > 0) {
          const playloadManageTurmas = {
            idMunicipio: idMunicipio,
            idUnidade: e.idue,
            idCampo: idCampo,
            ids: turmas
          }
          await this.$store.dispatch("setManageTurmas", playloadManageTurmas);

          const payloadManageUnidades = {
            idMunicipio: idMunicipio,
            idCampo: idCampo,
            ids: [e.idue],
          };
          await this.$store.dispatch("setManageUnidades", payloadManageUnidades);
        }
      });
    },

    async createAmostra() {
      if ((this.nome != '') && (this.ano != '') && (this.descricao != '') && ( typeof this.data === 'string' || this.municipioData != '')) {
        if (typeof this.data === 'string') {
          this.municipio = this.data;
        }
        else this.municipio = this.municipioData;
        const payload = {
          idMunicipio: this.municipio,
          titulo: this.nome,
          ano: String(this.ano),
          descricao: this.descricao,
        }
        await this.$store.dispatch('setCreateCampo', payload)
          .then(async () => {

            const payloadManageForms = {
              idMunicipio: this.municipio,
              idCampo: this.$store.getters.getIdCampo,
              ids: this.formularios
            };

            this.nome = "";
            this.descricao= "";
            this.municipioData = "";

            //se tiver forms cadastrados na regional, alocar por padrao todos os formularios
            if (this.formularios.length) {
              await this.$store.dispatch("setManageFormularios", payloadManageForms);
            }

            //achar ues que fazem parte, se tiver
            await this.$store.dispatch("setListUE", payloadManageForms);

            //se tiver ue, achar turmas e alocar por padrao todas essas turmas
            if (this.ues.length) {
              this.manageTurmas(this.municipio, this.$store.getters.getIdCampo);
            }

          });
        this.$emit('closeModal');
        this.$emit('emit');
        notyf.open({
          type: "success",
          message: "Campo adicionado com sucesso!",
        });
      }
    }
  }
}
</script>

<style scoped>
.container {
  padding: 1rem;
  width: 100%;
  background-color: white;
  margin: 0;
}

.title-style {
  font-size: 1.5rem;
  font-weight: 600;
  color: #656565;
}

.word-style {
  color: #656565;
}

.custom-form {
  margin: 0 auto;
}

.question-style {
  width: 100%;
  font-size: 1rem;
  font-weight: 500;
  color: #656565;
}

.button-div {
  text-align: right;
}
</style>
